/* eslint-disable quotes */
// pt-BR.js
export const portugues_brasil = {
  start: "Começar",
  save: "Salvar",
  delete: "Deletar",
  update: "Atualizar",
  lets: "Vamos jogar",
  permanentbuy: "Compra Permanente",
  signature: "Assinatura Mensal",
  signatureano: "Assinatura Anual",
  male: "Masculino  ",
  female: "Feminino",
  ambos: "Ambos",
  choosecategory: "Escolha as categorias",
  categories: "Categorias",
  light: "Leve",
  preliminary: "Preliminares",
  oral: "Oral",
  anal: "Anal",
  hot: "Quente",
  extreme: "Extremo",
  vd: "Verdade",
  dare: "Desafio",
  truth: "Verdade",
  time: "Tempo",
  createMyChallenges: "Criar Meus Desafios",
  chosen: "Selecionados",
  text3: "Deixe fluir o amor em você!",
  text4: "Prepare-se para viver intensamente",
  close: "Fechar",
  dev: "Desenvolvido por Dev12BR",
  next: "PRÓXIMO",
  config3: "Sem anúncios",
  config9: "Crie e edite seus próprios desafios",
  config10: "Categorias exclusivas",
  config11: "+ 800 novos desafios",
  version: "Versão Premium",
  alert3: "Selecione pelo menos uma categoria",
  tituloAlert1: "⚠️ O jogo ja vai começar 😜",
  duvidas: "Dúvidas ou Sugestões - Desafios Picantes",
  description: "Olá, minha dúvida ou sugestão é :",
  send: "Enviar",
  contact: "Contato",
  botaoApple: "Restaurar compras",
  alertCompra: "Sua compra esta sendo restaurada",
  NotPurchase: "Você não possui nenhuma compra",
  options: "Opções",
  avalie: "Avalie",
  novaCategoria: "Minhas categorias",
  alterLanguage: "Alterar o Idioma ?",
  textLanguage: "Ao trocar o idioma o aplicativo será reiniciado",
  textLanguage1: "Alterar o Idioma",
  cancel: "Cancelar",
  languages: "Linguagens",
  deletCat: "Deletar a categoria",
  textDeletCat:
    "Ao deletar esta categoria, os desafios presentes nesta categoria serão deletados. Após esta ação não poderá mais ser desfeita.",
  deletDes: "Deletar o desafio",
  textDeletDes:
    "Após deletar o desafio esta ação não poderá mais ser desfeita.",
  desafio: "Cadastrar Novo Desafio",
  desafiotexto: "Desafio",
  textoeditDesafio: "Quem pode fazer isso ?",
  textEmquem: "Em quem ?",
  nome: "Nome",
  inicio: "Começar o jogo",
  inicio9: "Ajuda",
  cadastrarCategory: "Cadastrar Categoria",
  inicio15: "Criando uma nova categoria",
  inicio16:
    "Passo 1 : Aperte o botão com o sinal de + que fica localizado na parte Inferior desta tela. Após apertar uma Janela vai aparecer para digitar a sua nova categoria.",
  inicio17: "Paso 2: Digite sua nova categoria e clique em salvar",
  inicio18:
    "Paso 3: Para editar esta categoria ou ADICIONAR OS DESAFIOS dentro da categoria aperte em cima dela.",
  inicio19:
    "Passo 4: Na próxima tela, apertando o botão indicado com a seta ⬆️, Vai abrir uma janela para edição da sua nova categoria.",
  inicio20:
    "Passo 5: Na próxima tela, apertando o botão indicado com a seta ⬆️, Você vai deletar a categoria.",
  inicio21:
    "Passo 1: Pressione o botão abaixo para adicionar um novo desafio a esta categoria",
  inicio22: "Criando um novo desafio",
  inicio23:
    "Passo 2: Aperte em cima de cada item circulado para saber em detalhe cada campo do cadastro",
  inicio24: "Texto do desafio",
  inicio25: `Escreva o desafio a seu gosto, e para que seja exibido o nome do jogador no desafio, basta apertar o botão vermelho abaixo. 
    
Ele vai adicionar os seguintes caracteres {nome}. 

** NÃO ALTERE ESTES CARACTERES ** Pois para que seja exibido o nome de acordo, precisa ficar como descrito abaixo ⬇️⬇️⬇️⬇️

Desafio: Beije o pescoço de {nome}`,
  inicio26: "Quem pode fazer, e quem pode receber",
  inicio27: `Selecione "Ambos" caso o desafio possa ser executado e recebido pelos participantes de "ambos" os gêneros.
  
Se o desafio for direcionado a um gênero basta selecionar o desejado.
`,
  inicio28: "Adicionando tempo ao desafio",
  inicio29:
    'Caso o seu desafio tenha um tempo, basta arrastar o "range" abaixo, e o valor será exibido acima. Após o tempo terminar no desafio, um som vai tocar avisando que acabou o desafio.',
  aviso12: `Aqui você cria apenas a categoria!
    
Para adicionar os desafios basta apertar no botão de sua categoria que acabou de ser criada ⬆️⬆️⬆️⬆️`,
  voltar: "Voltar",
  semDe: "Jogador sem desafios",
  semDe2: `Cadastre ao menos um desafio para este jogador 😬. 
  
Você será redirecionado a tela de login.`,
  term: "Privacidade",
  Potitic: "Termos de Uso",
  adquirited: "Adquirido",
  camera: "Câmera",
  galery: "Galeria",
  avatar: "Avatar",
  image: "Imagem",
  seletion: " Selecionados",
  editCategory: "Editar a categoria",
  frase1: "Está gostando dos desafios ?",
  frase2: "Que tal experimentar os Desafios Premium?",
  errTitulo: "Notou algo errado?",
  errCorrect: "Como seria em Protuguês ?",
  thisLanguageIsCorrect: "O desafio em PORTUGUÊS está correto?",
  yes: "Sim",
  no: "Não",
  errTexto:
    "Caso tenha encontrado algum erro de tradução, por favor corrija a frase no campo abaixo:",
  errSend: "Enviar sugestão",

  share: "Compartilhar",
  fraseShare: `Que aplicativo Top! Só compartilhando porque sei que você também vai gostar!🫣
Baixa aí e depois me conta se não é bom demais mesmo rs...😉
  
  
Link para download: https://desafiospicantesapp.page.link/share-app`,
  bandeira: "🇧🇷",

  morePlayer: "Jogar com mais jogadores ?",
  players: "Jogadores",
  carregar: "CARREGAR IMAGEM",
  takePhoto: "Tire uma foto ou selecione uma imagem",
  useAvatar: "OU USAR AVATARES",
  nomeHomem1: "Homem",
  nomeHomem2: "Homem",
  nomeMulher1: "Mulher",
  nomeMulher2: "Mulher",
  hetero: "Hétero",
  gay: "Gay",
  lesbico: "Lésbica",
  messageErr: "Adicione os jogadores 🙌",
  descricaoErr: "Digite os nomes dos participantes ✍️",
  why: "Nos diga o porque...",
  later: "Avaliar mais tarde",

  txtCard1: "Sua vez 🔥",
  txtCard2: "Faça acontecer 😘",
  txtCard3: "Vamos lá! 😜",
  txtCard4: "Próximo desafio 😈",
  txtCard5: "Mais um! 👄",

  //new
  tituloBloco1Novo: "Explore a Intimidade Sexual com o seu Parceiro",
  subtitulo1Novo: "Mais de 1 milhão de casais felizes",
  texto1Novo:
    "Destrave a intimidade e tenha acesso aos melhores jogos para casais! Desbloqueie agora todos os jogos, com diversas categorias criadas para vocês obterem o melhor da intimidade.",

  tituloBloco2Novo: "Novas experiências, melhor relacionamento",
  texto2Novo1: "Desfrute de mais de 1500 desafios",
  texto2Novo2: "Sem anúncios",
  texto2Novo3: "Com Avatares",
  texto2Novo4: "Novos desafios diários",
  texto2Novo5: "Novos Jogos regularmente",
  texto2Novo6: "Crie seus próprios desafios",
  texto2Novo7: "Categorias exclusivas",
  tituloBloco3Novo: "PONTUAÇÃO MÁXIMA NA CATEGORIA",
  tituloBloco4Novo: "Benefícios para a sua relação:",
  texto4Novo1: "Intimidade",
  texto4Novo2: "Desejo",
  texto4Novo3: "Leveza",
  texto4Novo4: "Atração",
  texto4Novo5: "Conexão",
  texto4Novo6: "Prazer",

  tituloBloco5Novo: "Veja a opinião de outros casais",
  texto5depoimentoTitulo1: "Luana Reis",
  texto5depoimento1: `Esse aplicativo é incrível! Estava na dúvida se deveria ou não o baixar, mas com certeza foi a melhor sensação que tivemos nos últimos tempos. Como é bom saber que ainda podemos fazer muitas coisas juntos. 🤭 Testamos a versão paga e realmente vale a pena, não tínhamos chegado nesse nível de prazer ainda.`,
  texto5depoimentoTitulo2: "Marcio Dantas",
  texto5depoimento2:
    "Se você quer apimentar a relação esse app é perfeito! Já tinha testado outros mais nenhum nos agradou como esse. As nossas preliminares ficaram bem mais quente e prazerosas (agora imagine o resto!) Realmente vale a pena comprar a versão paga (se você quiser sentir um prazer mais intenso) mas a versão grátis já surpreendeu também.",
  texto5depoimentoTitulo3: "Livia Antunes",
  texto5depoimento3:
    "Jogamos nesse último fim de semana e foi muito bom! Tem desafios que deram muito prazer de jogar 💦 foi incrível descobrir novas fantasias eróticas. Testamos outros jogos similares, tipo verdade ou desafios hot, jogos quentes para casais... e esse foi disparado o melhor jogo de sexo para casais. Vale a pena testar a versão paga se vocês estiverem muito frios na cama.",
  texto5depoimentoTitulo4: "Ricardo Jr",
  texto5depoimento4:
    "Ótimo! Muito bom mesmo... Ficamos com muito tesão durante o jogo o que fez o sexo ficar com muito mais pegada, foi prazer pra todo lado! Já estamos ansiosos pra jogar de novo 💦🔥 recomendamos a versão paga também se vocês aguentarem o tesão 🤤",

  tituloBloco6Novo:
    "Faça como centenas de casais ao redor do mundo e apimente sua vida amorosa. Descubra mais de 1500 novos desafios em casal.",
  texto6Select: "Selecione a versão:",
  texto6Premium: "Premium",
  texto6Assinatura: "Assinatura",
  texto6Mensal: "Mensal",
  texto6Anual: "Anual",
  texto6Vitalicia: "Vitalícia",
  bePremium: "Seja Premium",
  buyNew: "Começar Agora",

  attention: "Atenção !",
  changeGender: "Você mudou sua orientação sexual",

  //att v3
  tituloAvaliacao: "Gostando do jogo?",
  textoAvaliacao: "Avalie e nos ajude a continuar melhorando!",
  agoraNão: "Agora não",
  enviarAvaliacao: "Enviar",

  nomeJogo1: "Desafios Picantes",
  nomeJogo2: "Verdade ou Desafio?",
  nomeJogo3: "Nível de safadeza",
  nomeJogo4: "Sex Roleta",
  nomeJogo5: "Dicas quentes",

  playAlone: "Jogar Sozinho",
  estaSozinho: "Esta sozinho ?",
  selectPlayer: "Selecione o jogador",

  skip: "Pular",
  responder: "Enviar",
  respondaAqui: "Responda aqui",
  config4: "Escolha avatares para personalizar",

  tituloSelect1: "Está sem companhia?",
  tituloSelect2: "Responda perguntas comprometedoras!",

  subTituloSelect1: "A gente te da uma mãozinha!",
  subTituloSelect2: "Descubra o quão safado você é!",
  txtJogador1:
    "Selecione seu jogador e explore prazeres guiados feitos só para você!",
  txtJogador2: "O jogador selecionado responderá as perguntas",
  tituloCena: "QUAIS ITENS VOCÊ QUER USAR?",
  subTituloCena:
    "Não possui algum? Toque em “Obter” e adquira na loja parceira.",
  play: "Jogar",

  titleUserWarning: "Escolha um usuário",
  txtUserWarning: "Escolha um usuário para responder as perguntas",
  naughtyQuiz: "Quiz Safado",

  shareNivelDeSafadeza:
    "Ei, olha o meu nível de safadeza 😈 Experimente momentos intensos de prazer. Faça também 💋 Baixe o aplicativo agora e prepare-se para desfrutar de desafios quentes 🔥 com seu parceiro(a)!: ➡️ https://desafiospicantesapp.page.link/sharelevelhot",

  shareDica:
    "Transforme a sua vida amorosa agora mesmo! Baixe o aplicativo e descubra o segredo para um relacionamento picante: ➡️ https://desafiospicantesapp.page.link/tipoftheday",

  resultadoQuiz1:
    "Você é uma pessoa recatada, não curte muito a safadeza, prefere algo mais romântico!",
  resultadoQuiz2:
    "Você é romântico demais para abusar da safadeza, e curte mais o clima a luz de velas.",
  resultadoQuiz3:
    "Você é uma pessoa bastante reservada e acredita em manter as coisas mais discretas e privadas na vida íntima.",
  resultadoQuiz4:
    "Isso não quer dizer que você não seja safado/a às vezes, mas você prefere guardar todo esse fogo para gastar com alguém bem especial.",
  resultadoQuiz5:
    "Seu calor está em segundo plano, mas isso não muda o fato que há calor!",
  resultadoQuiz6:
    "Você gosta de explorar novas experiências, mas sempre com respeito e consentimento.",
  resultadoQuiz7:
    "Você adora um encontro quente, cheio de beijos e com muita pegação. Porém, existe um lado seu que também curte assistir um filminho segurando na mão do/a crush ou um jantarzinho à luz de velas.",
  resultadoQuiz8:
    "Você está disposto a experimentar coisas novas e emocionantes, mas sempre com responsabilidade.",
  resultadoQuiz9:
    "Você é uma pessoa ousada e gosta de apimentar as coisas na vida íntima de vez em quando.",
  resultadoQuiz10:
    "Você gosta de aproveitar todos os prazeres da vida, e não têm limite quando o assunto é sexo.",
  resultadoQuiz11:
    "Com você não tem tempo ruim e toda hora é hora de uma rapidinha! Filme de romance? Só se for 50 Tons de Cinza!",
  resultadoQuiz12:
    "Para você, a intimidade é uma aventura constante, e você não tem medo de correr riscos.",

  mes: "Mês",

  desafiosRestantesDois: "Você tem 2 desafios Premium restantes!",
  nenhumDesafioRestante: "Nenhum desafio Premium restante!",
  tornePremiumAviso1:
    "Torne-se premium agora e aproveite 1000 desafios Exclusivos!",
  tornePremiumAviso2:
    "Aproveite desafios ilimitados, conteúdo exclusivo e diversão sem interrupções!",
  conteudoPremium: "Você selecionou um conteúdo Premium!",
  aproveite4desafios:
    "Aproveite 4 desafios premium para provar um prazer exclusivo.",

  calculando: "Calculando Resultado...",
  nivelRomantismo: "SEU NÍVEL DE ROMANTISMO É:",
  finalizar: "Finalizar",
  erroQuizTitulo: "Digite a sua resposta",
  erroQuizFrase: "Para avançar digite sua resposta!",
  new: "NOVO APP",

  //resposta quiz safadeza
  resQuiz1: "Soca fofo",
  resQuiz2: "Romantico",
  resQuiz3: "Sedutor",
  resQuiz4: "Safadão",

  texto6Semanal: "Semanal",
  weekly: "Assinatura Semanal",
  tempSemanal: "Cobrado semanalmente",
  tempMensal: "Cobrado mensalmente",
  tempAnual: "Cobrado anualmente",
  tempSempre: "Pagamento único",
  canceleAny: "Cancele a qualquer momento",

  //Tela do safadrometro
  Low: "Fraco",
  Medium: "Mediano",
  High: "Alto",

  lifeTime: "Acesso vitalício",
  notNow: "Não agora, obrigado.",
  match: "MATCH COM A.I.",

  //Modal date
  dateTitle: "Quer conhecer nosso novo app?",

  dateBody:
    "Quer conversar com bots safados😈 e praticar seu chaveco? Você vai se divertir!🔥",
  goToDate: "Teste o Date.AI Agora!",

  goodForU: "FOI BOM PARA VOCÊ ?",
  rateOurPerformance: "Avalie nosso desempenho até aqui",
  veryGood: "Muito Bom",
  veryBad: "Muito Ruim",
  feedbackChallenge: `O que faria você compartilhar o app Desafios Picantes para outros casais e por que?`,
  type: "Digite sua resposta aqui...",
  survey: "Pesquisa de satisfação.",
  shareIfConfortable: "Se estiver confortável, compartilhe com amigos :)",

  howToPlay: "Como Jogar",
  howToPlayHotChallenge:
    "Prepare-se para apimentar as coisas! Pegue uma carta de desafio e surpreenda seu parceiro com uma ação quente!",

  // Pre game tips
  preGameTip1:
    "Liberte seus desejos e crie momentos inesquecíveis com seu parceiro!",
  preGameTip2: "Acenda suas paixões e crie momentos inesquecíveis juntos!",
  preGameTip3:
    "Explore seus desejos mais selvagens e crie memórias inesquecíveis!",
  preGameTip4: "Liberte suas fantasias e aproveite momentos de puro prazer!",
  selecionajoagador: "Hora de jogar",
  dica: "Dica",

  howToPlayNaughty:
    "Selecione seus brinquedos e objetos favoritos. Gire a roleta e deixe o destino decidir o seu próximo desafio picante!",
  howToPlayTruthOrDare:
    "Escolha seu destino: revele uma verdade ou aceite um desafio ousado. Que a diversão comece!",
  howToKama1: "Descubra Posições do Prazer – 365 Dias de Paixão!",
  howToKama2:
    "Escolha uma carta aleatória, tente a posição e explore novos patamares de prazer juntos!",

  kamaExplain:
    "Desbloqueie uma nova posição todos os dias e construa sua coleção definitiva de paixão – sua jornada de 365 dias de prazer inesquecível começa aqui!",
  howToDo: "Como fazer",
  pergunta: "Pergunta",

  restart: "Recomeçar",
  dialogText1HotChallenges:
    "Você fez todos os desafios disponíveis com as categorias selecionados.",
  dialogText2HotChallenges:
    "Selecione mais categorias ou reinicie o jogo com os desafios atuais!",
  noChallenges: "Sem Desafios!",

  objects: "Objetos",
  dialogText1NaughtyGames:
    "Você fez todos os desafios disponíveis com os objetos selecionados.",
  dialogText2NaughtyGames:
    "Selecione mais objetos ou reinicie o jogo com os desafios atuais!",
  unlockPremium: "Desbloquear Premium",

  noCategory: "Por favor, escolha pelo menos uma categoria para começar.",
  thanksForFeedback: "Obrigado por nos ajudar a melhorar a experiência!",
  categoryKamasutra: "Escolha sua paixão e jogue!",
  tap: "Toque para revelar sua posição!",
  step: "Guia Passo a Passo",
  shareQuizButton: "Compartilhe seu nível de safadeza!",
  tryAgain: "Tente novamente",
  unlockAllFun: "Desbloqueie toda a diversão",
  limitedOffer: "Oferta especial por tempo limitado!",
  fill: "Preencha o seu nome e do seu parceiro ou parceira.",

  kamaNotificationTitle: "🔥 Sua nova carta está liberada!",
  kamaNotificationBody:
    "Sua posição {variavel} dia está pronta. Que tal experimentar algo novo hoje? 💋",

  titleNewGame: "Prepare-se para o Roleplay!",
  phraseNewGame:
    "Na próxima atualização, um novo jogo para explorar suas fantasias mais criativas está chegando. Escolha personagens, crie histórias e eleve a diversão a um novo nível com seu parceiro. 🔥",
  awaitNewGame: "Aguarde e prepare-se para viver momentos únicos!",

  selectObjects:
    "Selecione dois ou mais itens para personalizar seu jogo. Explore ao máximo.",
  soon: "Em breve",
  wantToBeNotify: "Eu quero ser notificado",
  ok: "OK",
  vezDe: "VEZ DE",

  categoryLabel: "Categoria",
  descriptionLabel: "Descrição",

  loginConnect: "Conectar-se",
  loginNoAccount: "Não tem uma conta?",
  loginCreateNow: "Crie agora",
  loginOrConnect: "ou conecte com",

  email: "Email",
  password: "Senha",
  loginRegister: "Registrar-se",
  loginAlreadyHas: "Já tem uma conta?",
  enterNow: "Entre agora",

  logout: "Sair",
  customerPortal: "Portal do Cliente",
  installApp: "Instalar Aplicativo",
  loginVideo:
    "https://desafios-picantes-bucket.dev12br.com/videos-login/portugues-brasil.mp4",
};
